import {
	ACTION_SCRIPT,
	CSS,
	DJANGO,
	GRUNT,
	HANDLEBARS_JS,
	EXPRESS,
	FIREBASE,
	HTML,
	JAVASCRIPT,
	JEST,
	JQUERY,
	LESS_CSS,
	NODE_JS,
	PHP,
	PYTHON,
	REACT_JS,
	REACT_NATIVE,
	REDUX,
	SCSS,
	SQL,
	TechKey,
	TYPESCRIPT,
	WEBPACK,
	WORDPRESS,
	CLAUDE_CODE,
	PHP_MY_ADMIN,
	CURSOR,
} from '~const/Tech.const';

// Ordered for display by what I want to advertise first
export const DISPLAYED_LIST: TechKey[] = [
	// Frontend
	REACT_JS,
	REACT_NATIVE,
	REDUX,
	TYPESCRIPT,
	JAVASCRIPT,
	JEST,
	CSS,
	HTML,
	LESS_CSS,
	SCSS,

	// Backend
	NODE_JS,
	EXPRESS,
	DJANGO,
	HANDLEBARS_JS,
	PHP,
	PHP_MY_ADMIN,
	PYTHON,
	SQL,
	FIREBASE,

	// Content Management System
	WORDPRESS,

	// Tools
	CLAUDE_CODE,
	CURSOR,
	WEBPACK,
	GRUNT,

	// Legacy Tech
	JQUERY,
	ACTION_SCRIPT,
];
